export const INVALID_TOKEN_ERRORS = new Set([
	'errors.com.epicgames.common.authentication.authentication_failed',
	'errors.com.epicgames.common.authentication.token_verification_failed',
	'errors.com.epicgames.common.oauth.invalid_token',
	'epic.common.sso.missing_bearer_token',
	'epic.common.sso.session_invalid',
	'errors.com.epicgames.common.missing_permission'
]);
